import { LockSlice, ArenaStoreState } from '../arenaStoreTypes';
import { PendingActionPayload } from '../../state/ArenaPresenceService';
import { SeatPosition } from '../../state/ArenaTypes';

export type StoreSet = (
  partial: Partial<ArenaStoreState> | ((state: ArenaStoreState) => Partial<ArenaStoreState>)
) => void;
export type StoreGet = () => ArenaStoreState;

export const initialLockState = {
  isActionPending: false,
  remotePendingAction: null as PendingActionPayload | null,
  isBidInFlight: false,
  bidStartTime: 0,
  isPlayInFlight: false,
  playStartTime: 0,
  isBotStepInFlight: false,
  botStepStartTime: 0,
  lastUserInteractionTime: 0,
  lastTimeoutDispatchedAt: 0,
  lastTimeoutSeat: null as SeatPosition | null,
};

export const createLockSlice = (set: StoreSet, _get: StoreGet): LockSlice => ({
  ...initialLockState,

  setIsActionPending: (updater) =>
    set((state) => ({
      isActionPending: typeof updater === 'function' ? updater(state.isActionPending) : updater,
    })),

  setRemotePendingAction: (remotePendingAction) => set({ remotePendingAction }),

  setBidInFlight: (isBidInFlight, timestamp) =>
    set({
      isBidInFlight,
      bidStartTime: timestamp !== undefined ? timestamp : isBidInFlight ? Date.now() : 0,
    }),

  setPlayInFlight: (isPlayInFlight, timestamp) =>
    set({
      isPlayInFlight,
      playStartTime: timestamp !== undefined ? timestamp : isPlayInFlight ? Date.now() : 0,
    }),

  setBotStepInFlight: (isBotStepInFlight, timestamp) =>
    set({
      isBotStepInFlight,
      botStepStartTime: timestamp !== undefined ? timestamp : isBotStepInFlight ? Date.now() : 0,
    }),

  setLastUserInteractionTime: (lastUserInteractionTime) => set({ lastUserInteractionTime }),

  setLastTimeoutDispatched: (lastTimeoutSeat, time) =>
    set({
      lastTimeoutSeat,
      lastTimeoutDispatchedAt: time !== undefined ? time : Date.now(),
    }),
});
